import gql from "graphql-tag";

// fragment
export const SUPPLIER_FRAGMENT = gql`
    fragment supplier on SupplierNode {
        id
        name
        address1
        address2
        zipCode
        city
        country
        updatedAt
        updatedBy
    }
`;

// all query
export const SUPPLIERS_QUERY = gql`
    query {
        suppliers {
            edges {
                cursor
                node {
                    ...supplier
                }
            }
        }
    }
    ${SUPPLIER_FRAGMENT}
`;

// single query
export const SINGLE_SUPPLIER_QUERY = gql`
    query supplier($id: ID!) {
        supplier(id: $id) {
            ...supplier
        }
    }
    ${SUPPLIER_FRAGMENT}
`;

// create
export const CREATE_SUPPLIER_MUTATION = gql`
    mutation createSupplier($input: CreateSupplierInput!) {
        createSupplier(input: $input) {
            supplier {
                ...supplier
            }
        }
    }
    ${SUPPLIER_FRAGMENT}
`;

// update
export const UPDATE_SUPPLIER_MUTATION = gql`
    mutation updateSupplier($input: UpdateSupplierInput!) {
        updateSupplier(input: $input) {
            supplier {
                ...supplier
            }
        }
    }
    ${SUPPLIER_FRAGMENT}
`;

// delete
export const DELETE_SUPPLIER_MUTATION = gql`
    mutation deleteSupplier($input: DeleteSupplierInput!) {
        deleteSupplier(input: $input) {
            supplier {
                ...supplier
            }
        }
    }
    ${SUPPLIER_FRAGMENT}
`;
